import {faSearch} from '@fortawesome/free-solid-svg-icons/faSearch';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {Button, Col, Container, Row} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import config from '../../../config/app';
import {dateFormatFR} from '../../../utils';
import defaultBrand from '../../../common/assets/img/store.png';
import Image from '../../../common/components/Image';
import MandatoryInput from '../../../common/components/layout/MandatoryInput';
import PopIn from '../../../common/components/PopIn';
import TicketComments from './TicketComments';
import TicketPreview from './TicketPreview';
import TicketRating from './TicketRating';
import Panel from '../../../common/components/Panel';
import {HeadDiv} from '../../../common/components/StyledComp';

const ImageLogo = styled(Image)`
  max-height: 100px;
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

const DivBrandLeft = styled.div`
  padding-bottom: 20px;
  margin-bottom: 20px;
  border: 1px solid #acacc9;
  border-radius: 5px;
  margin-left: 10px;
  margin-top: 10px;
`;

const ReceiptUserDetails = ({receipt, t}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const date = dateFormatFR({date: receipt.createdAt});
  const brandName = receipt.brand.name;
  const brandLogoUrl = receipt.brand.file ? config.api_file_brand + receipt.brand.id + '?token=' + receipt.brand.file.token : defaultBrand;

  return (
    <div>
      <Button className="btn-update" style={{marginLeft: 15}} onClick={() => setModalVisible(true)}>
        <FontAwesomeIcon icon={faSearch} color="#329aef" size="sm"/>
      </Button>

      <PopIn visible={modalVisible} setModalVisible={setModalVisible} size='xl'
        title={t('popinDetails.title', {date, brandName})}>
        <Container className="general-container">
          <Row className="info-row">
            <Col xs={4}>
              <DivBrandLeft>
                <HeadDiv className="info-header">{`${t('popinDetails.brand')} : `}</HeadDiv>
                <ImageLogo
                  src={brandLogoUrl}/>
                <MandatoryInput
                  disabled
                  title={`${t('popinDetails.lastName')} : `}
                  name="brandName"
                  value={receipt.brand ? receipt.brand.name : ''}
                />
                {receipt.merchant && (
                  <>
                    <MandatoryInput
                      disabled
                      title={`${t('popinDetails.merchantLocalAddress')} : `}
                      name="merchantPhone"
                      value={receipt.merchant ? receipt.merchant.user.city + ' ' + receipt.merchant.user.postalCode : ''}
                    />
                    <MandatoryInput
                      disabled
                      title={`${t('popinDetails.merchantPhone')} : `}
                      name="merchantPhone"
                      value={receipt.merchant ? receipt.merchant.phoneNumber : ''}
                    />
                    <MandatoryInput
                      disabled
                      title={`${t('popinDetails.merchantEmail')} : `}
                      name="merchantEmail"
                      value={receipt.merchant ? receipt.merchant.contactEmail : ''}
                    />
                  </>
                )}
              </DivBrandLeft>
            </Col>
            <Col xs={8}>
              <Panel title={t('popinDetails.receiptThumbnail')} pdf={true}>
                <TicketPreview receipt={receipt}/>
              </Panel>
            </Col>
          </Row>

          {(receipt.rating || receipt.comments.length > 0) && (
            <Row className="info-row">
              <Col xs={12}>
                <Row className="section-info">
                  <HeadDiv className="info-header">{`${t('popinDetails.ticketReview')} : `}</HeadDiv>
                  <TicketRating receipt={receipt}/>
                  <TicketComments receipt={receipt}/>
                </Row>
              </Col>
            </Row>
          )}

        </Container>
      </PopIn>
    </div>
  );
};

ReceiptUserDetails.propTypes = {
  t: PropTypes.func.isRequired,
  receipt: PropTypes.shape({
    comments: PropTypes.array,
    brand: PropTypes.object,
    merchant: PropTypes.object,
    rating: PropTypes.number,
  }).isRequired,
};

export default withTranslation('ticket')(ReceiptUserDetails);
